import { BaseDestroy } from 'nera-common/angular';
import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';

@Component({
    selector: 'empty-layout',
    templateUrl: './empty.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [FuseLoadingBarComponent, RouterOutlet, TranslocoPipe],
})
export class EmptyLayoutComponent extends BaseDestroy {}
